module.exports = __webpack_public_path__ + "img/sr47_samurai02_shop.f96c2188.png";